export const API_KEY = process.env.REACT_APP_BACKEND_URL;
export const VERSION = '30102026';
